import request from '@/utils/request'
// 产品

//查询产品列表
export function queryProductByType(type) {
    return request.post('/front/content/queryProductByType?type=' + type)
}

//查询轮播图对应产品
export function queryCarouselProductById(id) {
    return request.post('/front/content/queryCarouselProductById?id=' + id)
}

//查询商品详情
export function queryAttributeValueByProductId(id) {
    return request.post('/front/content/queryAttributeValueByProductId?id=' + id)
}

//根据父级商品ID查询子商品
export function queryProductByParentId(id) {
    return request.post('/front/content/queryProductByParentId?id=' + id)
}

//生成下载页面二维码
export function createDownloadProductQRCode(id, router) {
    return request.post('/QRCode/createDownloadProductQRCode?id=' + id + '&router=' + router)
}

//在线预览PDF
export function createContact(param) {
    return request.post('/createPDF/createContact', param)
}